<template>
  <div class="multi-weatcher">
    <div class="card" v-for="(item,index) in componentData" :key="index">
      <div class="components">
        <div class="titles">
          <div @click="changeComponentIndex(index, index1)" v-for="(item1,index1) in item" :key="index1"
               :class="{'activate':componentIndex[index] === index1 }" class="title">{{ item1.name }}
          </div>
        </div>
        <div class="sk_btns" v-if="index === 0">
          <el-tooltip v-for="(item,index) in factsElement" class="item" effect="dark" :content="item.tip" :key="index"
                      placement="top" v-show="!item.hidden">
            <div class="btn" @click="handleSkElementClick(index)"
                 :class="{selected: factsIndex.includes(index), no_selected: !(factsIndex.includes(index))}"><img
              class="icon" :src="item.icon" :alt="item.name"></div>
          </el-tooltip>
        </div>
        <div class="btns" v-if="index === 1">
          <div class="btn" @click="item[0].moreHandle()">
            <div class="txt">更多</div>
            <div class="icon"><img src="@/assets/images/更多_icon.png"></div>
          </div>
        </div>
        <div class="btns" v-if="index === 2">
            <div @click="item[0].moreHandle()" class="btn">
              <div class="txt">更多</div>
              <div class="icon"><img src="@/assets/images/更多_icon.png"></div>
            </div>
        </div>
      </div>
      <div class="component">
        <keep-alive>
          <component :showTime="componentData[index][componentIndex[index]].showTime"
                     :is="componentData[index][componentIndex[index]].ename"
                     :key="componentData[index][componentIndex[index]].ename" style="padding: 0 1.2vw;position: static">
          </component>
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
import MultiWearherWqsk from '@/components/module/card/multi-wearher-wqsk.vue'
import MultiWearherRiskForecast from '@/components/module/card/multi-wearher-risk-forecast.vue'
import ThreeForest from '@/components/module/card/three-forest.vue'
import HourForest from '@/components/module/card/hour-forest.vue'
import ThreeRisk from '@/components/module/card/three-risk.vue'
import InstantRisk from '@/components/module/card/instant-risk.vue'
import { mapState } from 'vuex'
import SevenDayRiskForecast from '@/components/module/card/seven-day-risk-forecast.vue'

export default {
  components: {
    SevenDayRiskForecast,
    MultiWearherWqsk,
    MultiWearherRiskForecast,
    ThreeForest,
    ThreeRisk,
    InstantRisk,
    HourForest
  },
  props: ['params'],
  name: 'multiWeather',
  data () {
    return {
      labelid: '',
      componentIndex: [0, 0, 0],
      factsIndex: [0, 1, 2, 3, 5],
      factsElement: [{
        name: 'temp',
        icon: require('@/assets/images/温度_sk_icon.png'),
        tip: '温度'
      }, {
        name: 'windd_dir',
        icon: require('@/assets/images/风速_sk_icon.png'),
        tip: '风力风向'
      }, {
        name: 'r01h',
        icon: require('@/assets/images/降雨_sk_icon.png'),
        tip: '小时降雨'
      }, {
        name: 'rh',
        icon: require('@/assets/images/湿度_sk_icon.png'),
        tip: '湿度'
      }, {
        name: 'p',
        icon: require('@/assets/images/气压_sk_icon.png'),
        tip: '气压'
      }, {
        name: 'light',
        icon: require('@/assets/images/光照强度_sk_icon.png'),
        tip: '光照强度',
        hidden: true
      }],
      componentData: [
        [
          {
            name: '天气实况',
            ename: 'multiWearherWqsk'
          }
        ],
        [
          {
            name: '24小时预报',
            ename: 'hourForest',
            showTime: false,
            showMore: true,
            moreHandle: () => {
              this.$bus.$emit('showSevenDayForecast')
            }
          },
          {
            name: '三天预报',
            ename: 'threeForest',
            showTime: false
          }
        ],
        [
          {
            name: '即时风险',
            ename: 'instantRisk',
            showMore: true,
            moreHandle: () => {
              this.$bus.$emit('showSevenDayRiskForecast')
            }
          },
          {
            name: '三天风险',
            ename: 'multiWearherRiskForecast'
          }
        ]
      ],
      initRiskTypeCountActivate: false
    }
  },
  watch: {
    riskTypeCountResult () {
      // this.riskTypeCountActivate()
    }
  },
  mounted () {
    const el = this.factsIndex.map(v => this.factsElement[v].name)
    this.$bus.$emit('factsElement', el)
  },
  computed: {
    ...mapState('home', ['riskTypeCountResult'])
  },
  created () {
    this.getUnitLabelId()
    this.factsElement[5].hidden = this.labelid === 4
  },
  methods: {
    getUnitLabelId () {
      const company = this.$route.params.company
      const { unit } = JSON.parse(localStorage.getItem(company))
      this.labelid = unit.labelid
    },
    handleSkElementClick (index) {
      if (this.factsIndex.includes(index)) {
        const elIndex = this.factsIndex.findIndex(item => item === index)
        if (elIndex > -1) {
          this.factsIndex.splice(elIndex, 1)
        }
      } else {
        this.factsIndex.push(index)
      }
      const el = this.factsIndex.map(v => this.factsElement[v].name)
      this.$bus.$emit('factsElement', el)
    },
    changeComponentIndex (index, index1) {
      this.$set(this.componentIndex, index, index1)
    },
    riskTypeCountActivate () {
      const riskTypeCountResultList = this.riskTypeCountResult
      if (riskTypeCountResultList.length === 0) {
        return
      }
      const activate = riskTypeCountResultList.findIndex(v => v.num > 0) !== -1
      if (activate) {
        this.$set(this.componentIndex, 2, 1)
      }
      this.initRiskTypeCountActivate = true
      return activate
    }
  }
}
</script>

<style lang="less" scoped>
.multi-weatcher {
  .card {
    margin-bottom: .6rem;

    .components {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: .4vw 1.2vw .4vw;

      .titles {
        display: flex;

        .title {
          cursor: default;
          font-weight: 500;
          font-size: 1.2rem;
          line-height: 24px;
          text-shadow: 0px 2px 1px rgba(8, 42, 73, 0.37);
          text-align: left;
          font-style: normal;
          margin-right: 1rem;
          color: #8aa0b5;
        }

        .activate {
          color: #78E4F2;
        }
      }

      .btns {
        .btn {
          cursor: default;
          display: flex;
          justify-content: center;
          align-items: center;

          .txt {
            color: #FFFFFF;
            font-weight: 500;
            opacity: .4;
            display: flex;
            margin-right: 8px;
          }

          .icon {
            img {
              width: 5px;
              height: 9px;
            }
          }
        }
      }

      .sk_btns {
        display: flex;
        align-items: center;

        .btn {
          width: 2rem;
          height: 2rem;
          margin-left: .5rem;
          display: flex;
          justify-content: center;
          align-items: center;

          .icon {
            width: 1.2rem;
            height: 1.2rem;
          }
        }

        .selected {
          background-image: url("../../../assets/images/选中_sk.png");
          background-size: 100% 100%;
        }

        .no_selected {
          background-image: url("../../../assets/images/未选中_sk.png");
          background-size: 100% 100%;
        }
      }
    }
  }
}
</style>
